import styled from 'styled-components'

import { Flex } from '@/@bothrs-ui/web/components/layout'
import { breakpoints } from '@/config/layout'

const StCard = styled(Flex)`
  ${({ theme }) => `
    background-color: ${theme.Components.Card.Fill};
    border: 1px solid ${theme.Components.Card.Border};
    border-radius: ${theme.UI.BorderRadius.Large}px;
    padding: ${theme.UI.SpacingPx.Space4};
    gap: ${theme.UI.SpacingPx.Space3};
    position: relative;
  `}

  @media ${breakpoints.s} {
    border-width: 2px;
  }
`

const StChevron = styled.div`
  ${({ theme }) => `
    position: absolute;
    bottom: ${theme.UI.SpacingPx.Space4};
    right: ${theme.UI.SpacingPx.Space4};
  `}
`

export { StCard, StChevron }
